import { ClientType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const clientTypeName: { [key in ClientType]: TKeyType } = {
  [ClientType.DESKTOP]: 'client.desktop',
  [ClientType.MOBILE]: 'client.mobile'
}

export default clientTypeName
